<template>
  <div class="content">
    <el-row style="height: 3vh; padding-left: 0.5vw; padding-top: 0.1vh">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>黑名单管理</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>

    <!-- 主体 -->
    <el-container class="content-container">
      <el-main style="height: 100%;padding:0px !important;  position: relative;width: 100%;">
        <el-card style="margin-bottom: 8px;">
          <!-- 上 -->
          <div class="date-section" style="margin-bottom:10px">
            <div style="display:flex;align-items:center;justify-content: space-between;">
              <div style="display:flex;align-items:center;margin-right:20px">
                <span style="margin-right:10px;font-size:0.8vw !important;">录入日期:</span>
                <el-date-picker v-model="search.date" type="daterange" start-placeholder="选择开始日期"
                  end-placeholder="选择结束日期" value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
              <el-button type="primary" @click="addFun" plain>添加</el-button>
            </div>
          </div>
        </el-card>

        <el-card>
          <div class="search-section" style="border-bottom: 1px dashed rgb(239, 233, 233);">
            <div
              style="height:6vh;position: relative;display:flex;align-items: center;">
              <p style="height:5vh;display:flex;align-items:center;">事件类型：</p>
              <div style="display:flex;flex-wrap:wrap;justify-content: flex-start;align-content: flex-start;">
                <p class="type-item" :class="(search.typeEvent==''?'selIndex':'')" @click="typeSearch('')"
                  style="margin:0 1vw 0 0;">不限</p>
                <p class="type-item" :class="(search.typeEvent== item.value?'selIndex':'')" @click="typeSearch(item.value)" v-for="item in badTypeList"
                  :key="item.value"
                  style="margin:0 1vw 0 0;">{{item.label}}</p>
                <!-- <p class="type-item" :class="(search.typeEvent=='0'?'selIndex':'')" @click="typeSearch('0')"
                  style="margin:0 1vw 0 0;">不服从项目管理</p>
                <p class="type-item" :class="(search.typeEvent=='1'?'selIndex':'')" @click="typeSearch('1')"
                  style="margin:0 1vw 0 0;">违章操作</p>
                <p class="type-item" :class="(search.typeEvent=='3'?'selIndex':'')" @click="typeSearch('3')"
                  style="margin:0 1vw 0 0;">恶意欠薪</p>
                <p class="type-item" :class="(search.typeEvent=='2'?'selIndex':'')" @click="typeSearch('2')"
                  style="margin:0 1vw 0 0;">恶意讨薪</p>
                <p class="type-item" :class="(search.typeEvent=='4'?'selIndex':'')" @click="typeSearch('4')"
                  style="margin:0 1vw 0 0;">其他</p> -->
              </div>
            </div>
          </div>

          <el-form :inline="true" :model="formInline" class="form-inline">
            <el-form-item label="姓名">
              <el-input v-model="formInline.personName" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="身份证号">
              <el-input v-model="formInline.idCard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
            <el-form-item label="劳务企业">
              <el-input v-model="formInline.entName" placeholder="请输入劳务企业名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="query" plain>查询</el-button>
            </el-form-item>
          </el-form>
          <!-- <div class="query-button">
            
          </div> -->
        </el-card>

        <div style="width: 100%;display: flex;justify-content: flex-end;padding: 5px 0;">
          
          <!-- <el-button type="primary" plain>申请删除</el-button>
          <el-button type="primary" plain>导出Excel</el-button> -->
        </div>

        <el-dialog title="添加黑名单" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-row>
              <el-col :span="12">
                <el-form-item label="所在劳动企业" :label-width="formLabelWidth">
                  <!-- <el-input v-model="form.personName" placeholder="请输入所在劳动企业"></el-input> -->
                  <el-select v-model="form.entId" style="width: 100%" placeholder="请选择参建单位" filterable @change="toGetTeams">
                    <el-option v-for="item in joinEnts" :key="item.emtId" :label="item.entName" :value="item.emtId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="所在班组" :label-width="formLabelWidth">
                  <el-select v-model="form.teamsId" placeholder="请选择班组" @change="toGetPerson" style="width: 100%;">
                    <el-option v-for="item in teamList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <el-form-item label="姓名" :label-width="formLabelWidth">
                  <el-select v-model="form.personId" style="width: 100%" placeholder="请选择工人" filterable>
                    <el-option v-for="item in personList" :key="item.personId" :label="item.name" :value="item.personId">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="事件类别" :label-width="formLabelWidth">
                  <el-select v-model="form.badRecordType" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in badTypeList" :key="item.id" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="12">
                <!-- <el-form-item label="时效性" :label-width="formLabelWidth">
                  <el-select v-model="value" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item> -->
                <el-form-item label="严重程度" :label-width="formLabelWidth">
                  <el-select v-model="form.severity" placeholder="请选择" style="width: 100%;">
                    <el-option v-for="item in sevList" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                
              </el-col>
            </el-row>

            <el-form-item label="不良记录原因" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="form.desc" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
            </el-form-item>

            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input type="textarea" v-model="form.remarks" :autosize="{ minRows: 4, maxRows: 6}"></el-input>
            </el-form-item>

            <el-form-item label="附件" :label-width="formLabelWidth">
              <el-upload class="upload-demo" v-bind:action="uploadUrl" :headers="uploadHead"
                :data="uploadData" :show-file-list="false" :on-success="fileSuccess">
                <i v-if="!form.annexAddresses||form.annexAddresses==''" class="el-icon-plus avatar-uploader-icon"></i>
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <img v-if="form.annexAddresses" src="../../assets/image/fileicon.png" style="width:5vh;height:5vh;" />
                  <span v-if="form.annexAddresses">{{form.fileName}}</span>
                </div>
              </el-upload>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="submitFun">确 定</el-button>
          </div>
        </el-dialog>

        <el-card >
          <el-table :data="tableData" border height="51vh"  style="width: 100%">
            <el-table-column label="序号" prop="index" width="100">
            </el-table-column>
            <el-table-column prop="personName" label="姓名" width="180">
            </el-table-column>
            <el-table-column prop="idcard" label="身份证号">
            </el-table-column>
            <el-table-column prop="entName" label="劳务企业">
            </el-table-column>
            <el-table-column prop="entName" label="事件类型">
              <template slot-scope="scope">
                <span>{{changeType(scope.row.badRecordType)}}</span>
                <!-- <span v-if="scope.row.badRecordType=='0'">不服从项目管理</span> -->
                <!-- <span v-else-if="scope.row.badRecordType=='1'">违章操作</span>
                <span v-else-if="scope.row.badRecordType=='2'">恶意讨薪</span>
                <span v-else-if="scope.row.badRecordType=='3'">恶意欠薪</span>
                <span v-else-if="scope.row.badRecordType=='5'">违法乱纪</span>
                <span v-else>其他</span> -->
              </template>
            </el-table-column>
            <el-table-column prop="createDate" label="录入时间">
            </el-table-column>
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </el-card>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import myHttp from '../../untils/port'
  import util from '../../untils/util'
  export default {
    data() {
      return {
        groupId:'',
        search: {
          date: '',
          typeEvent: '' // 事件类型
        },
        formInline: {
          personName: '',
          idCard: '',
          entName:''
        },
        tableData: [],
        currentPage: 1,
        pageSize:10,
        //新增数据表单
        dialogFormVisible: false,
        form: {
          personName: '',
          annexAddresses: '',//附件地址
          badRecordType: '',//类型
          type: '',//1不良 2奖励 3黑名单
          entId:'',//参建单位
          teamsId:'',//班组id
          personId: '',
          projectId:'',
          desc: '',//描述
          remarks:'',//备注
          fileName:''
        },
        formLabelWidth: '120px',
        //弹出框获取数据
        joinEnts:[],
        teamList:[],
        personList:[],
        badTypeList:[  //类型
         
        ],
        sevList:[  //严重性
          {id:'1',name:'一般'},
          {id:'2',name:'严重'}
        ],
        //上传
        uploadUrl:myHttp.uploadFile,
        uploadHead:{
          accessToken: util.session.get('token')
        },
        uploadData:{
          type:'217'
        },
        total: 0
      }
    },
    mounted(){
      this.groupId = util.session.get('groupId')
      this.getEnt()
      this.getData()
      this.getListByLikeType()
    },
    methods: {
      // 获取奖惩列表
      getListByLikeType(){
        myHttp.getListByLikeType({
          type: '_record'
        }).then(resp => {
          console.log(resp)
          if(resp.data.code === 200){
            this.badTypeList = resp.data.data.dictList
          }
        })
      } ,

      changeType(type){
        for(let i=0;i<this.badTypeList.length;i++){
          if(type == this.badTypeList[i].value){
            return this.badTypeList[i].label
          }
        }
      },

      //获取参建单位
      getEnt(){
        var that = this
        myHttp.getProjectEntByProjectId({
          projectId:this.groupId
        }).then(function(resp){
          if(resp.data.code=='200'){
            var list = resp.data.data.projectEnt || []
            that.joinEnts = list
          }
        })
      },
      //根据参建单位获取班组
      toGetTeams(){
        var that = this
        if(this.form.entId==''){
          this.teamList = []
          this.form.teamsId = ''
          this.personList = []
          this.form.personId = ''
        }else{
          var projectEntId = this.getProEntId(this.form.entId)
          myHttp.getTeams({
            projectEntId:projectEntId,
            projectId:this.groupId,
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.pageInfo||[]
              that.teamList = list
            }
          })
        }
      },
      //获取
      getProEntId(id){
        var list = this.joinEnts
        var result = ''
        for(var i=0;i<list.length;i++){
          if(list[i].emtId==id){
            result = list[i].projectEntId
          }
        }
        return result
      },
      //根据班组获取人员
      toGetPerson(){
        var that = this
        if(this.form.teamsId==''){
          this.personList = []
          this.form.personId = ''
        }else{
          myHttp.selectProjectPersonInfoList({
            projectId:this.groupId,
            teamsId: this.form.teamsId,
          }).then(function(resp){
            if(resp.data.code=='200'){
              var list = resp.data.data.entity || []
              that.personList = list
              // console.log(list)
            }
          })
        }
      },
      /**
       * 获取数据列表
       */
      getData(){
        var that = this
        myHttp.selectBadRecordListByProjectId({
          projectId:this.groupId,
          personName:this.formInline.personName,
          type:'',
          idCard:this.formInline.idCard,
          entName:this.formInline.entName,
          badRecordType:this.search.typeEvent,
          startTime:this.search.date[0],
          endTime:this.search.date[1],
          pageNum:this.currentPage,
          pageSize:this.pageSize
        }).then(function(resp){
          console.log(resp)
          if(resp.data.code=='200'){
            var list = resp.data.data.entity.list||[]
            for(var i=0;i<list.length;i++){
              list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
            }
            that.tableData = list
            that.total = resp.data.data.entity.total
          }
        })
      },
      //选择事件类型
      typeSearch(index) {
        this.search.typeEvent = index ? index : ''
      },
      // 查询
      query() {
        this.getData()
      },
      // 分页
      handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getData()
      },
      //添加
      addFun(){
        this.dialogFormVisible = true
        this.form= {
          personName: '',
          annexAddresses: '',//附件地址
          badRecordType: '',//类型
          type: '',//1不良 2奖励 3黑名单
          entId:'',//参建单位
          teamsId:'',//班组id
          personId: '',
          projectId:'',
          desc: '',//描述
          remarks:'',//备注
          fileName:''
        }
        // this.joinEnts = []
        // this.teamList = []
        // this.personList = []
      },
      // 添加数据
      submitFun() {
        var that = this
        console.log(this.form.badRecordType);
        console.log(this.badTypeList);
        for(let i=0;i<this.badTypeList.length;i++){
          if(this.form.badRecordType == this.badTypeList[i].value){
            console.log(this.badTypeList[i]);
            if(this.badTypeList[i].type == 'bad_record'){
              this.form.type = 1
            }else if(this.badTypeList[i].type == 'award_record'){
              this.form.type = 2
            }
          }
        }
        console.log(this.form.type);
        this.form.personName = this.getNameById()
        this.form.projectId = this.groupId
        myHttp.createBadRecord(this.form).then(function(resp){
          if(resp.data.code=='200'){
            that.$message.success('添加成功')
            that.dialogFormVisible = false
            that.getData()
          }
        })
      },
      //获取人员名称
      getNameById(){
        var result = ''
        for(var i=0;i<this.personList.length;i++){
          if(this.personList[i].personId==this.form.personId){
            result = this.personList[i].name
          }
        }
        return result
      },
      //上传成功
      fileSuccess(res,file){
        // console.log(res,file)
        if(res.code=='200'){
          var url = res.data.saveUrls
          this.form.annexAddresses = url
          this.form.fileName = file.name
        }else{
          this.$message.error(res.msg)
        }
      },
    }
  }
</script>
<style scoped>
  .search-section {
    display: flex;
  }

  .search-section div p {
    font-size: 0.8vw !important;
  }

  .search-section div div p {
    cursor: pointer;
    height: 3vh;
    line-height: 3vh;
    padding: 0 1vh;
    border-radius: 2px;
  }

  .selIndex {
    background: #409eff;
    color: #fff;
  }

  .selIndex:hover {
    color: #fff;
  }

  .form-inline {
    display: flex;
    width: 90%;
    justify-content: space-between;
    margin-top: 10px;
  }

  .query-button {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
  ::v-deep .el-card__body{
    padding-bottom:0 !important;
  }
</style>
<style>
  .upload-demo{
    text-align: left;
  }
</style>